import { TilesCarousel } from '@shared/components/tiles-carousel/TilesCarousel';
import * as React from 'react';

import type { YourAlertsProps } from './YourAlerts.types';

import styles from './YourAlerts.module.css';

const YourAlerts = React.memo(
  ({ children }: Readonly<YourAlertsProps>): React.ReactElement => {
    return (
      <section
        className={styles.yourAlerts}
        data-testid="your-alerts"
        aria-labelledby="your-alerts-title"
      >
        <h2 className="heading-02" id="your-alerts-title">
          Your alerts
        </h2>
        <TilesCarousel>{children}</TilesCarousel>
      </section>
    );
  }
);

YourAlerts.displayName = 'YourAlerts';

export { YourAlerts };
